import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export default function QRPreview({ value }: { value: string }) {
  const [pngDataUrl, setPngDataUrl] = useState<string | null>(null);
  const [svgMarkup, setSvgMarkup] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const png = await QRCode.toDataURL(value, {
        width: 320,
        margin: 1,
        errorCorrectionLevel: 'M',
      });
      const svg = await QRCode.toString(value, {
        type: 'svg',
        margin: 1,
        errorCorrectionLevel: 'M',
      });
      if (!cancelled) {
        setPngDataUrl(png);
        setSvgMarkup(svg);
      }
    })();
    return () => { cancelled = true; };
  }, [value]);

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="rounded-xl border border-slate-200 bg-white p-3">
        {pngDataUrl ? (
          <img src={pngDataUrl} alt="QR code" className="h-40 w-40" />
        ) : (
          <div className="h-40 w-40 animate-pulse bg-slate-100" />
        )}
      </div>
      <div className="flex gap-2">
        <a
          href={pngDataUrl ?? '#'}
          download={`qr-${safeFile(value)}.png`}
          aria-disabled={!pngDataUrl}
          className="btn-secondary text-xs"
        >
          PNG
        </a>
        <a
          href={
            svgMarkup
              ? `data:image/svg+xml;utf8,${encodeURIComponent(svgMarkup)}`
              : '#'
          }
          download={`qr-${safeFile(value)}.svg`}
          aria-disabled={!svgMarkup}
          className="btn-secondary text-xs"
        >
          SVG
        </a>
      </div>
    </div>
  );
}

function safeFile(s: string) {
  return s.replace(/^https?:\/\//, '').replace(/[^a-z0-9_-]+/gi, '-').slice(0, 40);
}
